import { useEffect, useRef } from 'react';
import { withSearch } from '@elastic/react-search-ui';
import { isMapFilter } from '../utils/mapFilters';

function MapFilterLogger({ filters }) {
  const prevRef = useRef('');

  useEffect(() => {
    const mapFilters = (filters || []).filter(f => isMapFilter(f.field));
    const serialized = JSON.stringify(mapFilters);
    if (serialized === prevRef.current) return;
    prevRef.current = serialized;

    if (mapFilters.length === 0) {
      return;
    }

    const lines = mapFilters.flatMap(f =>
      f.values.map(v => `  ${f.field}: ${v}`),
    );
    console.info(['[map filters]', ...lines].join('\n'));
  }, [filters]);

  return null;
}

export default withSearch(({ filters }) => ({ filters }))(MapFilterLogger);
